import React, { Component } from 'react';
import { Route, withRouter } from 'react-router-dom';
import classNames from 'classnames';
import { IconLoader } from 'common/IconLoader';
import { withAuth } from 'components/shared/Auth';
import LandingLayout from 'components/features/LandingLayout';
import './LoginPage.css';

const LoginEnum = {
  LOGIN: 0,
  RESET_PASSWORD: 1,
  RESET_SUCCESS: 2,
  RESET_FAIL: 3,
  CHANGE_PASSWORD: 4
};

const LoginError = {
  NONE: 0,
  NO_USERNAME: 1,
  NO_PASSWORD: 2,
  LOGIN_FAILED: 3,
  INVALID_EMAIL: 4
};

class LoginPage extends Component {
  constructor(props) {
    super(props);

    this.state = {
      username: '',
      password: '',
      email: '',
      usernameFocused: false,
      passwordFocused: false,
      emailFocused: false,
      loginEnum: LoginEnum.LOGIN,
      loginError: LoginError.NONE
    };

    this.loginEnter = this.loginEnter.bind(this);
    this.resetEnter = this.resetEnter.bind(this);
  }

  checkValidEmail(string) {
    /* This isn't a thorough check, but there's no damage done if an invalid email does get through.*/
    return string.includes('@') && string.includes('.') && !string.includes(' ');
  }

  loginEnter(event) {
    window._mfq = window._mfq || [];
    window._mfq.push(['formSubmitAttempt', '#loginForm']);

    event.preventDefault();
    if (this.state.username === '') {
      this.setState({ loginError: LoginError.NO_USERNAME });
      window._mfq.push(['formSubmitFailure', '#loginForm']);
    } else if (this.state.password === '') {
      this.setState({ loginError: LoginError.NO_PASSWORD });
      window._mfq.push(['formSubmitFailure', '#loginForm']);
    } else {
      this.props.auth.embeddedLogin(this.state.username, this.state.password, (err) => {
        window._mfq.push(['formSubmitFailure', '#loginForm']);
        console.log('login error:', err);
        this.setState({ loginError: LoginError.LOGIN_FAILED, password: '' });
      });

      window._mfq.push(['formSubmitSuccess', '#loginForm']);
    }
  }

  resetEnter() {
    if (this.checkValidEmail(this.state.email)) {
      this.props.auth.resetPassword(this.state.email, (err) => {
        if (err) {
          console.log('pasword reset error:', err);
          //this.setState({loginEnum: LoginEnum.RESET_FAIL});
          this.props.history.push('/login/reset-password-fail');
        } else {
          this.props.history.push('/login/reset-password-success');
          //this.setState({loginEnum: LoginEnum.RESET_SUCCESS});
        }
      });
    } else {
      this.setState({ loginError: LoginError.INVALID_EMAIL });
    }
  }

  render() {
    let errorText = '';
    switch (this.state.loginError) {
      case LoginError.NO_USERNAME:
        errorText = 'Please enter a username';
        break;
      case LoginError.NO_PASSWORD:
        errorText = 'Please enter a password';
        break;
      case LoginError.LOGIN_FAILED:
        errorText = 'The username or password is incorrect';
        break;
      case LoginError.NONE:
      default:
        break;
    }

    return (
      <LandingLayout>
        <Route
          exact
          path={this.props.match.path + '/'}
          render={(props) => {
            return (
              <form onSubmit={(e) => e.preventDefault()} id="loginForm" className="LoginPage_MainBox">
                <div className="LoginPage_LoginText">Login to your account</div>
                <div
                  className={classNames({
                    LoginPage_Username_Div: true,
                    LoginPage_Username_Error: this.state.loginError === LoginError.NO_USERNAME
                  })}
                >
                  <div className="LoginPage_Username_Icon_Div">
                    <img
                      className="LoginPage_Username_Icon"
                      alt={'username icon'}
                      src={
                        this.state.loginError === LoginError.NO_USERNAME
                          ? IconLoader.icon_login_mail_error
                          : this.state.usernameFocused
                          ? IconLoader.icon_login_mail_on
                          : IconLoader.icon_login_mail
                      }
                    />
                  </div>
                  <input
                    className="LoginPage_Username_Input"
                    type="text"
                    value={this.state.username}
                    onChange={(evt) => {
                      if (this.state.loginError === LoginError.NO_USERNAME) {
                        this.setState({
                          username: evt.target.value,
                          loginError: LoginError.NONE
                        });
                      } else {
                        this.setState({ username: evt.target.value });
                      }
                    }}
                    onFocus={(evt) => {
                      this.setState({ usernameFocused: true });
                    }}
                    onBlur={(evt) => {
                      this.setState({ usernameFocused: false });
                    }}
                    onKeyPress={(evt) => {
                      if (evt.key === 'Enter') {
                        this.loginEnter(evt);
                      }
                    }}
                  />
                </div>
                <div
                  className={classNames({
                    LoginPage_Password_Div: true,
                    LoginPage_Password_Error: this.state.loginError === LoginError.NO_PASSWORD
                  })}
                >
                  <div className="LoginPage_Password_Icon_Div">
                    <img
                      className="LoginPage_Password_Icon"
                      alt={'passowrd icon'}
                      src={
                        this.state.loginError === LoginError.NO_PASSWORD
                          ? IconLoader.icon_login_password_error
                          : this.state.passwordFocused
                          ? IconLoader.icon_login_password_on
                          : IconLoader.icon_login_password
                      }
                    />
                  </div>
                  <input
                    className="LoginPage_Password_Input"
                    type="password"
                    value={this.state.password}
                    onChange={(evt) => {
                      if (
                        this.state.loginError === LoginError.LOGIN_FAILED ||
                        this.state.loginError === LoginError.NO_PASSWORD
                      ) {
                        this.setState({
                          password: evt.target.value,
                          loginError: LoginError.NONE
                        });
                      } else {
                        this.setState({ password: evt.target.value });
                      }
                    }}
                    onFocus={(evt) => {
                      this.setState({ passwordFocused: true });
                    }}
                    onBlur={(evt) => {
                      this.setState({ passwordFocused: false });
                    }}
                    onKeyPress={(evt) => {
                      if (evt.key === 'Enter') {
                        this.loginEnter(evt);
                      }
                    }}
                  />
                </div>
                <div className="LoginPage_Error_Div">{errorText}</div>
                <div
                  className="LoginPage_ForgotPassword_Text"
                  onClick={() => {
                    this.props.history.push('/login/reset-password');
                    //this.setState({loginEnum: LoginEnum.RESET_PASSWORD});
                  }}
                >
                  Forgot password?
                </div>

                <button className="LoginPage_MainBox_LogIn" onClick={(event) => this.loginEnter(event)}>
                  Log in
                </button>
              </form>
            );
          }}
        />
        <Route
          exact
          path={this.props.match.path + '/reset-password'}
          render={(props) => {
            return (
              <div className="LoginPage_MainBox">
                <div className="LoginPage_Reset_Text">Enter the email you use for your IBMS account</div>
                <div
                  className={classNames({
                    LoginPage_Email_Div: true,
                    LoginPage_Username_Error: this.state.loginError === LoginError.INVALID_EMAIL
                  })}
                >
                  <div className="LoginPage_Username_Icon_Div">
                    <img
                      className="LoginPage_Username_Icon"
                      alt={'username icon'}
                      src={
                        this.state.loginError === LoginError.INVALID_EMAIL
                          ? IconLoader.icon_login_mail_error
                          : this.state.emailFocused
                          ? IconLoader.icon_login_mail_on
                          : IconLoader.icon_login_mail
                      }
                    />
                  </div>
                  <input
                    className="LoginPage_Username_Input"
                    type="text"
                    value={this.state.email}
                    onChange={(evt) => {
                      this.setState({ email: evt.target.value });
                    }}
                    onFocus={(evt) => {
                      this.setState({ emailFocused: true });
                    }}
                    onBlur={(evt) => {
                      this.setState({ emailFocused: false });
                    }}
                    onKeyPress={(evt) => {
                      if (evt.key === 'Enter') {
                        this.resetEnter();
                      }
                    }}
                  />
                </div>
                <div className="LoginPage_Reset_Error_Div">
                  {this.state.loginError === LoginError.INVALID_EMAIL ? 'Please enter a valid email' : ''}
                </div>
                <button className="LoginPage_MainBox_LogIn" onClick={this.resetEnter}>
                  Submit
                </button>
              </div>
            );
          }}
        />
        <Route
          exact
          path={this.props.match.path + '/reset-password-success'}
          render={(props) => {
            return (
              <div className="LoginPage_MainBox">
                <div className="LoginPage_ResetSuccess_Title"> Check your email to reset your password </div>
                <div className="LoginPage_ResetSuccess_Text">
                  <p>
                    If there is an existing IBMS account associated with {this.state.email} you will receive an email
                    containing a link to reset your password
                  </p>
                  <p>If you do not receive a link, check your spam filter and confirm that the email is correct</p>
                  <p>
                    For further assistance, contact us at{' '}
                    <a href="mailto:support@pivotalcommware.com">support@pivotalcommware.com</a>
                  </p>
                </div>
              </div>
            );
          }}
        />
        <Route
          exact
          path={this.props.match.path + '/reset-password-fail'}
          render={(props) => {
            return (
              <div className="LoginPage_MainBox">
                <div className="LoginPage_ResetFail_Text">
                  <p>
                    An unexpected error has occured. If this problem persists, please email us at{' '}
                    <a href="mailto:support@pivotalcommware.com">support@pivotalcommware.com</a>
                  </p>
                </div>
              </div>
            );
          }}
        />
      </LandingLayout>
    );
  }
}

export default withAuth(withRouter(LoginPage));
